import axios from 'axios';
import {actions as A} from '../constants/actions';
import {api} from '../constants/api';
import {errors as E} from 'common/constants/errors';

export const sendContactMail = (data) => {
  return (dispatch) => {
    dispatch({
      type: A.SEND_CONTACT_MAIL
    });

    return axios.post(api.SEND_CONTACT_MAIL, data)
      .then((response) => {
        const {errorCode, body} = response.data;
        if (errorCode < 0) throw new Error(E.SERVER_ERROR);

        dispatch({
          type: A.SEND_CONTACT_MAIL_SUCCESS,
          payload: body
        });
      })
  };
};
